module.exports = __webpack_public_path__ + "media/images/sandbox/knuckles--thumb-943f0f4a91231c3827689408789b9f5a.png";